import React from 'react'
import { Grid } from '@mui/material'


import Text from 'components/Text'
import ToolsCard from 'screens/GetStarted/components/ToolsCard/ToolsCard'

import background from 'assets/img/tools1.png'
import background2 from 'assets/img/tools2.png'
import background3 from 'assets/img/tools3.png'
import background4 from 'assets/img/tools4.png'
import styles from 'screens/ToolsSlider/sections/Section5/Section5.module.css'

const cardData = [
  {
    id: '1',
    label: 'E&R U.S. 500',
    imageUrl: background
  },
  {
    id: '2',
    label: 'E&R U.S. 100',
    imageUrl: background2
  },
  {
    id: '3',
    label: 'Fama & F',
    imageUrl: background3
  },
  {
    id: '4',
    label: 'Sentiment',
    imageUrl: background4
  }
]

export default function Section5() {
  return <div className={styles.container}>
    <Grid xs={12} sm={6} item flexDirection='column' p='100px' >
      <Text size='3.5rem'>
        Sand Box
      </Text>
      <Text size='3.5rem' fontWeight='bold' mb='40px'>
        For Data Owners
      </Text>
      <Text size='1.875rem'>
        If you are a data owner running an online retail
        store, or you are an environmental research
        foundation generating climate data, or you are
        a sentiment analytics company assisting various
        global brands to predict consumer sentiment
        regarding their products, we can assist you in
        generating and indexing systematic prediction
        for your data.
      </Text>
    </Grid>
    <Grid container xs={12} sm={6} item flexDirection='row'   >
      {cardData.map((card) => {
        return <Grid key={card.id} container item xs={6} justifyContent='center' alignItems='center' p='10px' mt={['3', '4'].includes(card.id) && '50px'}>
          <ToolsCard imageUrl={card.imageUrl} label={card.label} />
        </Grid>
      })}
    </Grid>
  </div >
}
